/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

import swal from "sweetalert";

import {
  AppBar,
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { Link } from "react-router-dom";
import { appConstants } from "utils/appConstants";

import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import CustomText from "components/customtext/customtext";
import Height from "components/height/height";
import PageTitle from "examples/PageTitle/PageTitle";
import Printer from "examples/Printer/printer";

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import QrCodeIcon from '@mui/icons-material/QrCode';
import { BTable } from "components/BTable/BTable";
import NewDataTable from "components/NewDataTable/NewDataTable";
import ViewCard from "components/ViewCard/ViewCard";
import { useDispatch } from "react-redux";
import { addLoadVehicleAndSlotByID, allocateDriverFinalDeliveryByID, assignDriverToPrimeByID, generateOrderQRCodeByID, getDriver, getDroplocation, getLoadPlanVehicle, getLoadedSlot, getOrderItemsWarehouse, getPrimeMover, getSummaryByLoadType, getSummaryByLoadedVehicleID, getWarehouseOrderForAllocate, getWarehouseOrderForFinalDelivery, getWarehouseRecieveData, getWarehouses, recieveOrderByID, updatPlanLoadStatusByID } from "utils/api";
import { generateDataList, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  display: 'grid',
  justifyContent: 'center'
};
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
const style1 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  display: 'grid',
  // justifyContent:'center'
};


let LOGIN_DETAILS;
let EMPLOYEE_DETAILS;
let LPV;
let LPV1;
let OneID;
// let selectedNormalSlot= [];
// let selectedMezzSlot=[];
let locedData;
function WarehouseDashboard() {

  const modalRef = useRef();
  const [table, setTable] = useState("received");
  const [selectDriverErr, setSelectDriverErr] = useState(false);
  const [showSubscriptionPlanTable, setShowSubscriptionPlanTable] = useState(false);
  const [showReceived, setShowReceived] = useState(false);
  const [showPlanFeatureTable, setShowPlanFeatureTable] = useState(false);
  const [showLocked, setShowLocked] = useState(false);
  const [showOrderRecieved, setShowOrderRecieved] = useState(false);

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [rows4, setRows4] = useState([]);

  const [rows7, setRows7] = useState([]);
  const [checkLogin, setCheckLogin] = useState(false);
  const [lock, setlock] = useState("")
  const [slotData, setSlot] = useState([])
  const [mezzSlot, setMezzSlot] = useState([])
  const [openRecieveOrder, setOpenRecieveOrder] = useState(false)


  const [selectedNormalSlot, setSelectedNormalSlot] = useState([])
  const [selectedMezzSlot, setSelectedMezzSlot] = useState([])
  const [screenName, setScreenName] = useState("Warehouse Dashboard");
  const [showVehicleDropdown, setVehicleDropdown] = useState(false);
  const [showLockVehicle, setLockVehicleDropdown] = useState(false);

  const [vehicle, setVehicle] = useState([]);
  const [driver, setDriver] = useState([]);
  const [lockedVehicle, setLockedVehicle] = useState([]);
  const [primeMover, setPrimeMover] = useState([]);
  const [rows5, setRows5] = useState([]);

  const [assignVehicleErr, setAssignVehicleErr] = useState(false);
  const [assignloadPlanVehicleErr, setAssignloadPlanVehicleErr] = useState(false);
  const [assignDropWarehouseErr, setAssignDropWarehouseErr] = useState(false);
  const [assignDriverErr, setAssignDriverErr] = useState(false);

  const [dropLocation, setDropLocation] = useState([]);
  const [pallet, setPallet] = useState(0);
  const [balanceVolume, setBalanceVolume] = useState(0);
  const [loadedVolume, setLoadedVolume] = useState(0);
  const [trailerTypeUI, setTrailerTypeUI] = useState(false);
  const [vehicleValues, setVehicleValues] = React.useState({})
  const [selectedNames, setSelectedNames] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [sectedOrderItems, setSectedOrderItems] = useState([]);
  const [sectedOrder, setSectedOrder] = useState([]);
  const [finalRow, setRowsFinal] = useState([]);
  const [finalDeliveryOrders, setFinalDeliveryOrders] = useState([]);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [totalRowsLoaded, setTotalRowsLoaded] = useState(0);
  const [customerReload, setCustomerReload] = useState();

  let mandateFlag = false;
  const [values, setValues] = React.useState({
    vehicleID: "",
    loadPlanVehiclesID: "",
    dropWarehouseID: "",
    assignedDriverID: "",
    loadPlanVehicleID: "",
    orderDropWarehouseID: "",
    slotNumber: "",
    totalPalletVolume: "",
    orderItemIDS: "",
    loadedVolume: "",
    loadedWeight: "",
    balanceVolume: "",
    warehouseID: "",
    deliveryType: "Warehouse to Warehouse",
    selectedOrderItemsIDS: [],
    selectedOrderIDS: [],
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
  });



  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const [valuesSummary, setValuesSummary] = React.useState({
    loadPlanVehicleID: "",
    loadType: "Warehouse to Warehouse"

  });

  const handleChangeSummary = (name) => (event) => {
    setValuesSummary({ ...valuesSummary, [name]: event.target.value });
  };


  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  values.businessUserID = LOGIN_DETAILS.businessUserID;
  EMPLOYEE_DETAILS = JSON.parse(sessionStorage.getItem('Employee_Details'));
  values.warehouseID = EMPLOYEE_DETAILS.employeeWarehouseLocation;

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
       The event listener that's calling the handleTabsOrientation function when resizing the window.
      */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);
  const dispatch = useDispatch()


useEffect(()=>{
Promise.all([
  fetchLoadedPlanVehicle(),
  fetchPrimeMover(),
  fetchDriver(),
  fetchWarehouseOrderByStatus()
])
},[])

  const [filterText, setFilterText] = React.useState("");
  const [filterBarcode, setFilterBarcode] = React.useState("");
  const [barCodeErr, setBarCodeErr] = React.useState(false);
  const [openModal, setOpenModal] = useState(false)
  const [openAssignDriver, setOpenAssignDriver] = useState(false)
  const frontEndURL = appConstants.frontendURL;

  function cancel() {
    setOpenModal(false);
    setOpenAssignDriver(false)
  }

  useEffect(() => {
    setlock(values.vehicleStatus)
  }, [values.vehicleStatus])


  const generateQRCode = async (id) => {
    const payload = { url: frontEndURL, id: id, }
    generateOrderQRCodeByID(payload, async (data) => {
      let fetchPDFDetail = data.Result_Output;
      if (fetchPDFDetail && fetchPDFDetail.path !== "") {
        await axios.get(`${appConstants.baseURL}user/downloadPDFFile`, {
          responseType: 'blob',
          params: { fileName: `pdfFiles/${fetchPDFDetail.path}` }
        })
          .then((response) => {
            const file = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = `BossFM_OrderNo_${fetchPDFDetail.orderNumber} ${new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).replace(/\//g, '-')}`;
            link.click();
            setLoading(false);
          }).catch((error) => {
            console.error('Error occurred while downloading file:', error.message);
            setLoading(false);
          });
      } else {
        console.log(`Something went wrong while download the File. `);
      }
      setTimeout(async () => {
        await axios.post(appConstants.baseURL + 'user/deleteQR_PDFFile', { fileName: fetchPDFDetail.path })
          .then(
            async (res) => {
            }
          )
      }, 2000);
    }, dispatch)
  }


  const fetchWarehouseOrderByStatus = async () => {
    getWarehouseRecieveData(values, (data) => {
      if (data.Result_Output.docs.length > 0) {
        setTotalRows(data.Result_Output.totalDocs)
        setRows(data.Result_Output.docs)
      }
    }, dispatch)
  };

  const fetchWarehouseOrderByStatus1 = async () => {
    getWarehouseOrderForAllocate({ warehouseID: values.warehouseID }, (data) => {
      if (data.Result_Output.length > 0) {
        setRows4(data.Result_Output.sort((a, b) => b.orderNumber - a.orderNumber))
      }else{
        setRows4([])
      }
    }, dispatch)
  };

  const fetchWarehouseOrderForFinalDelivery = async () => {
    getWarehouseOrderForFinalDelivery({ warehouseID: values.warehouseID }, (data) => {
      if (data.Result_Output.length > 0) {
        setRowsFinal(data.Result_Output.sort((a, b) => b.orderNumber - a.orderNumber))
      }else{
        setRows4([])
      }
    }, dispatch)

  };

  const fetchLoadedPlanVehicle = async () => {
    getLoadPlanVehicle({ businessUserID: values.businessUserID, warehouseID: values.warehouseID }, (data) => {
      if (data.Result_Output.length > 0) {
        setVehicle(data.Result_Output)
        let LockedItem = []
        for (let val of data.Result_Output) {
          if (val.vehicleStatus === "Locked") {
            LockedItem.push(val)
          }
        }
        setLockedVehicle(LockedItem)
      }
    }, dispatch)

  };

  const fetchDriver = async () => {
    getDriver({ businessUserID: values.businessUserID }, (data) => {
      if (data.Result_Output.length > 0) {
        setDriver(data.Result_Output)
      }
    }, dispatch)
  };

  const handleRecieveOrder = async () => {
    if (sectedOrder.length === 0) {
      showResMsg(genericMessage.selectAtleastOneOrder, 1000, false);
      return
    }
    setOpenRecieveOrder(true)
  }

  const recieveOrder = async () => {
    setOpenRecieveOrder(false)
    recieveOrderByID(values, (data) => {
      if (data.Result_Status) fetchWarehouseOrderByStatus()
      showResMsg(data.Result_Status ? genericMessage.recieveOrder : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)

  };



  const [selected, setSelectedValue] = useState([]);

  useEffect(() => {
    fetcWarehouse()
  }, [selectedNames])


  const fetcWarehouse = async () => {
    values.loadPlanVehiclesID = selectedNames
    getWarehouses(values, async (data) => {
      setWarehouse(await generateDataList(data.Result_Output, "warehouseID", "warehouseName"));
    }, dispatch)

  };


  const slotsHandleChange = (name, index) => event => {
    if (event.target.checked) {
      const newData = [...selectedNormalSlot, slotData[index]];
      setSelectedNormalSlot(newData);
    } else {
      const newArray1 = selectedNormalSlot.filter(item => item.slotNumber !== index + 1);
      setSelectedNormalSlot(newArray1)
    }

  }
  useEffect(() => {
    console.log("selectedNormalSlot1", selectedNormalSlot)
  }, [selectedNormalSlot])

  const mezzSlotsHandleChange = (name, index) => event => {
    if (event.target.checked) {
      const newData = [...selectedMezzSlot, mezzSlot[index]];
      setSelectedMezzSlot(newData);
    } else {
      const newArray = selectedMezzSlot.filter(item => (item.slotNumber !== index + 1));
      setSelectedMezzSlot(newArray)
    }
  }

  useEffect(() => {
    for (let data of rows) {
      if (data.orderID === selected) {

        values.orderNumber = data.orderNumber
      }
    }
    OneID = selected;
    values.orderID = OneID
    fetchOrderItems(OneID);

  }, [selected]);

  const fetchOrderItems = async (id) => {
    getOrderItemsWarehouse({ orderID: id }, (data) => {
      if (data.Result_Output.length > 0) {
        setRows7(data.Result_Output);
      } else {
        setRows7([]);
      }
    }, dispatch)

  };


  const fetchPrimeMover = async () => {
    getPrimeMover({ businessUserID: values.businessUserID }, async (data) => {
      if (data.Result_Output.length > 0) {
        setPrimeMover(await generateDataList(data.Result_Output, "_id", "registrationNumber"))
      }

    }, dispatch)

  };



  const handleChange4 = ({ selectedRows }) => {
    setFinalDeliveryOrders(selectedRows)
  };

  const handleChange1 = ({ selectedRows }) => {
    setSectedOrderItems(selectedRows)
    values.selectedOrderItemsIDS = selectedRows
  };
  const handleChange2 = ({ selectedRows }) => {
    setSectedOrder(selectedRows)
    values.selectedOrderIDS = selectedRows
  };
  let arr = []
  useEffect(() => {
    const OrderItemVolume = sectedOrderItems.map(volum => (volum.breadthInMm * volum.heightInMm * volum.lengthInMm) / 1000000000)
    const totalOrderItemVoume = OrderItemVolume.reduce((sum, value) => sum + value, 0);
    let selectedData = selectedNormalSlot.concat(selectedMezzSlot)
    const totalBalanceVolume = selectedData.map(obj => obj.balanceVolume).reduce((total, balance) => total + balance, 0)
    let updatedArr = []
    console.log("orderVol", selectedNormalSlot)
    let loop2 = 0
    if (sectedOrderItems.length > 0) {
      for (let data of sectedOrderItems) {
        let loopLength = 0
        let orderArr = []
        // console.log(data.breadthInMm , data.heightInMm , data.lengthInMm)
        let orderVol = ((data.breadthInMm * data.heightInMm * data.lengthInMm) / 1000000000).toFixed(2)
        if (selectedData.length > 0) {
          if (selectedData.length === 1) {
            console.log("selectedMezzSlot", selectedMezzSlot.length, data, vehicleValues.mezzHeigh)
            if (selectedMezzSlot.length > 0) {
              if (data.heightInMm > vehicleValues.mezzHeight) {
                swal({
                  title: "Item Height is greater then Mezz Height",
                  text: "",
                  icon: "error",
                  color: 'red',
                  button: false,
                  timer: 3000
                });
              }
            }
            let orderVol = ((data.breadthInMm * data.heightInMm * data.lengthInMm) / 1000000000).toFixed(2)
            if (selectedData[0].balanceVolume < orderVol) {
              swal({
                title: "Order Item Volume is greater than Slot Volume, will you still want to continue?",
                text: "",
                icon: "error",
                color: 'red',
                button: false,
                timer: 3000
              })


            }
            // selectedData[0].loadedVolume += parseFloat(orderVol)
            // selectedData[0].balanceVolume = (selectedData[0].balanceVolume  - orderVol).toFixed(2)
            // let ff = slotData.map(obj => selectedData.find(o => o._id === obj._id) || obj);
            // console.log("ff" , ff)
          } else {
            for (let slot of selectedData) {
              if (slot.balanceVolume < orderVol) {

                loopLength += 1
              } else {

                console.log("Sufficient")
              }
              if (loopLength > 0) {
                swal({
                  title: "Order Item Volume is greater than Slot Volume, you need to choose additional Slot for Allocation!",
                  text: "",
                  icon: "error",
                  color: 'red',
                  button: false,
                  timer: 2000
                })
              }

              if (selectedMezzSlot.length > 0) {
                if (data.heightInMm > vehicleValues.mezzHeight) {

                  loop2 += 1
                }

                if (loop2 > 0) {
                  swal({
                    title: "Item Height is greater than Mezz Height",
                    text: "",
                    icon: "error",
                    color: 'red',
                    button: false,
                    timer: 3000
                  });
                }
              }
            }
          }
        }
      }
    }

  }, [sectedOrderItems, selected, selectedMezzSlot, selectedNormalSlot])

  useEffect(() => {
    if (valuesSummary.loadType !== undefined && valuesSummary.loadType !== '') {
      setValues((prevValues) => ({
        ...prevValues,
        page: appConstants.page,
        limit: appConstants.limit,
        filterValues: "",
      }));
      LPV1 = valuesSummary.loadType;
      fetchSummaryByLoadType(LPV1)
    }
  }, [valuesSummary.loadType]);

  const fetchSummaryByLoadedVehicleID = async (id) => {
    getSummaryByLoadedVehicleID({ loadPlanVehicleID: id }, (data) => {
      if (data.Result_Output.length > 0) {
        setRows1(data.Result_Output)
      } else {
        setRows1([])
      }
    }, dispatch)
  };

  const fetchSummaryByLoadType = async (val) => {
    if(val !== "" && val !== undefined){
      values.loadType = val
    }
    
    getSummaryByLoadType(values, (data) => {
      if (data.Result_Output.docs.length > 0) {
        setTotalRowsLoaded(data.Result_Output.totalDocs)
        setRows5(data.Result_Output.docs)
      } else {
        setRows5([])
        setTotalRowsLoaded(0)
      }
    }, dispatch)

  };

  useEffect(() => {
    if (values.loadPlanVehicleID !== undefined && values.loadPlanVehicleID !== '') {
      LPV = values.loadPlanVehicleID;
      fetchLoadedSlot(LPV);
    }
  }, [values.slotNumber , customerReload])


  useEffect(() => {

    if (vehicleValues.upperPalletCount !== "" && vehicleValues.upperPalletCount !== undefined) {

      if (values.trailerPalletType === "upperPallet") {
        setPallet(vehicleValues.upperPalletCount)
      } else {
        setPallet(vehicleValues.belowPalletCount)

      }
    }
  }, [values.trailerPalletType])


  useEffect(() => {
    if (values.loadPlanVehicleID !== undefined && values.loadPlanVehicleID !== '') {
      LPV = values.loadPlanVehicleID;
      console.log('LPV', LPV);
      // fetchPalletFromVehicle(LPV);
      fetchDroplocation(LPV);
      fetchSummaryByLoadedVehicleID(LPV)
      for (let data of vehicle) {
        if (data._id === values.loadPlanVehicleID) {
          setVehicleValues(data)
          setTrailerTypeUI(data.trailerType)
          setlock(data.vehicleStatus);
        }
      }
      fetchLoadedSlot()
    }

  }, [values.loadPlanVehicleID]);

  const lockTrailor = async (event) => {
    setCheckLogin(!checkLogin);
    setOpenModal(false);
    if (lock === "" || lock === undefined) {
      showResMsg(genericMessage.selectLoadVehicle, 1000, false)
      return

    }
    if (lock === "New") {
      values.vehicleStatus = "Locked";
    } else if (lock === "Locked") {
      values.vehicleStatus = "New";
    }

    updatPlanLoadStatusByID(values, (data) => {
      showResMsg(data.Result_Message, 1000, data.Result_Status)
    }, dispatch)

  };
  const clearErrState =()=>{
    setAssignVehicleErr(false);
    setAssignloadPlanVehicleErr(false);
    setAssignDropWarehouseErr(false);
    setAssignDriverErr(false);
  }

  const saveDriver = async (event) => {
    mandateFlag = false;
    clearErrState()
    mandateFlag = validateField(values.vehicleID, setAssignVehicleErr) || mandateFlag;
    mandateFlag = validateField(values.loadPlanVehiclesID, setAssignloadPlanVehicleErr) || mandateFlag;
    mandateFlag = validateField(values.dropWarehouseID, setAssignDropWarehouseErr) || mandateFlag;
    mandateFlag = validateField(values.assignedDriverID, setAssignDriverErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    setOpenAssignDriver(false)
    values.loadPlanVehiclesID = selectedNames
    assignDriverToPrimeByID(values, (data) => {
      if(data.Result_Status)
      setCustomerReload(!customerReload)
      showResMsg(data.Result_Status ? genericMessage.driverAssign : data.Result_Message, 1000, data.Result_Status)

    }, dispatch)
  };

  const fetchLoadedSlot = async (id) => {
    getLoadedSlot({ loadPlanVehicleID: values.loadPlanVehicleID, slotNumber: values.slotNumber, trailerPalletType: values.trailerPalletType }, (data) => {
      if (data.Result_Status) {

        setSlot(data.Result_Output.normalPallet)
        setMezzSlot(data.Result_Output.mezzPallet)


        if (data.Result_Output.loadedVolume && data.Result_Output.balanceVolume !== "" && data.Result_Output.loadedVolume && data.Result_Output.balanceVolume !== undefined) {
          setLoadedVolume(data.Result_Output.loadedVolume)
          setBalanceVolume(data.Result_Output.balanceVolume)
          values.loadedVolume = data.Result_Output.loadedVolume
          values.balanceVolume = data.Result_Output.balanceVolume
        } else {
          setLoadedVolume(0)
          setBalanceVolume(0)
          values.loadedVolume = 0
          values.balanceVolume = 0
        }
      } else {
        setBalanceVolume(values.totalPalletVolume)
        setLoadedVolume(0)
        values.balanceVolume = values.totalPalletVolume
      }
    }, dispatch)

  };

  const fetchDroplocation = async (id) => {
    getDroplocation({ loadPlanVehicleID: id }, (data) => {
      if (data.Result_Output.length > 0) {
        setDropLocation(data.Result_Output)
      }
    }, dispatch)

  };


  const allocateDriverFinalDelivery = async () => {

    mandateFlag = false;
    if (values.assignedDriverID === undefined || values.assignedDriverID.toString().trim() === "") {
      setSelectDriverErr(true);
      mandateFlag = true;
    } else setSelectDriverErr(false);

    if (mandateFlag) {
      return;
    }
    values.finalDeliverSelectedOrders = finalDeliveryOrders
    sessionStorage.setItem("PARA_TABLE", "allocated");
    allocateDriverFinalDeliveryByID(values, (data) => {
      showResMsg(data.Result_Status ? genericMessage.updated : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)

  };

  const addLoadVehicleAndSlot = async () => {

    if (values.orderDropWarehouseID.toString().trim() === "") {
      showResMsg(genericMessage.dropLoaction, 1000, false);
      return

    }
    if (sectedOrderItems.length === 0) {
      showResMsg(genericMessage.oneOrderItem, 1000, false);
      return

    }
    if (selectedNormalSlot.concat(selectedMezzSlot).length === 0) {
      showResMsg(genericMessage.oneSlot, 1000, false);
      return
    }
    setLoading(true);
    sessionStorage.setItem("PARA_TABLE", "allocated");
    values.balanceVolume = balanceVolume
    values.loadedVolume = loadedVolume
    values.selectedNormalSlot = selectedNormalSlot
    values.selectedMezzSlot = selectedMezzSlot
    values.selectedItems = sectedOrderItems

    addLoadVehicleAndSlotByID(values, (data) => {
      if(data.Result_Status)
      setCustomerReload(!customerReload)
      showResMsg(data.Result_Status ? genericMessage.added : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)

  };

  let VehicleList = (vehicle).length > 0
    && (vehicle).map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>{item.registrationNumber},{item.vehicleType},{item.palletCount}</MenuItem>
      )
    }, this);
  let primeMoverList = (primeMover).length > 0
    && (primeMover).map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>{item.registrationNumber}</MenuItem>
      )
    }, this);


  let DropLocationList = (dropLocation).length > 0
    && (dropLocation).map((item, i) => {
      return (
        <MenuItem key={i} value={item.dropWarehouseID}>{item.warehouseName},{item.warehouseCity}</MenuItem>
      )
    }, this);


  let DriverList = (driver).length > 0
    && (driver).map((item, i) => {
      if (item.job === 0) {
        return (
          <MenuItem key={i} value={item._id}>{item.firstName},{item.lastName}</MenuItem>
        )
      }

    }, this);

  const [showViewDetails, setShowViewDetails] = useState(false)

  function setPrreview() {
    if (values.loadPlanVehicleID.toString().trim() === "") {
      showResMsg(genericMessage.selectLoadVehicle, 1000, false);
      return
    }
    // fetchSummaryByLoadedVehicleID(values.loadPlanVehicleID)
    setShowViewDetails(true)
  }
  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === 'allocated') {
      setTable('allocated');
    }
    if (sessionStorage.getItem("PARA_TABLE") === 'locked') {
      setTable('locked');
    }
    if (sessionStorage.getItem("PARA_TABLE") === 'received') {
      setTable('received');
    }
    if (table === "received") {
      setShowReceived(true);
      setShowSubscriptionPlanTable(false);
      setShowLocked(false);
      setShowOrderRecieved(false)
      setShowPlanFeatureTable(false);
      setTabValue(0)
      setValues((prevValues) => ({
        ...prevValues,
        page: appConstants.page,
        limit: appConstants.limit,
        filterValues: "",
      }));
      fetchWarehouseOrderByStatus();
    } else if (table === "allocated") {
      console.log("Adasdsa" , customerReload , table)
      fetchWarehouseOrderForFinalDelivery()
      setShowReceived(false);
      setShowSubscriptionPlanTable(false);
      setShowLocked(false);
      setShowPlanFeatureTable(true);
      setShowOrderRecieved(false)
      setTabValue(1)
      fetchWarehouseOrderByStatus1()
    }
    else if (table === "locked") {
      setShowReceived(false);
      setShowLocked(true);
      setShowPlanFeatureTable(false);
      setShowOrderRecieved(false)
      setTabValue(2)
      setValues((prevValues) => ({
        ...prevValues,
        page: appConstants.page,
        limit: appConstants.limit,
        filterValues: "",
      }));
      fetchSummaryByLoadType()
    }

    sessionStorage.removeItem("PARA_TABLE");
  }, [table , customerReload]);





  // let filteredItems

  // filteredItems = rows4.filter(function (currentElement) {
  //   if (filterBarcode !== "" && filterBarcode !== undefined) {
  //     return (
  //       (currentElement.barCodeID && currentElement.barCodeID.toString().includes(filterBarcode))
  //     )
  //   } else {
  //     const filterLowerCase = filterText.toLowerCase();
  //     return (
  //       (currentElement.senderName && currentElement.senderName.toLowerCase().includes(filterLowerCase)) ||
  //       (currentElement.orderNumber && currentElement.orderNumber.toString().includes(filterLowerCase)) ||
  //       (currentElement.orderDate && currentElement.orderDate.toLowerCase().toString().includes(filterLowerCase)) ||
  //       (currentElement.weightInKg && currentElement.weightInKg.toString().includes(filterLowerCase))
  //     )
  //   };
  // });


  useEffect(() => {

    if (filterBarcode !== "" && filterBarcode !== undefined) {
      if (filterBarcode.split("").length !== 10) {
        setBarCodeErr(true)
        return
      } else {
        setBarCodeErr(false)
        // setFilterText(filterBarcode)

      }
    }
  }, [filterBarcode])

  const customData = rows4.map(datum => ({ ...datum, lock: "" }));
  // console.log("customData",customData)



  useEffect(() => {
    if (lock === "Locked") {
      for (let res of customData) {
        locedData = res;
      }
    } else if (lock === "New") {
      locedData = false;
    }

  }, [lock])

  const rowDisabledCriteria = row => locedData;




  const handlePageChange = page => {
    values.page = page;
    setCustomerReload(!customerReload)
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage
    setCustomerReload(!customerReload)
  };
  const handleSort = async (type, value) => {
    console.log("sfsdfs", type, value)
    values.sortingType = value;
    values.sortingField = type;
    setCustomerReload(!customerReload)
  };
  const ordersColumns = [
    {
      name: "Customer Name ",
      selector: (row) => {
        return `${row.senderName} ${row.customerCode !== undefined && row.customerCode !== "" ? "(" + row.customerCode + ")" : ""}`;
      },
      sortable: true,

    },
    {
      name: "Consignment Numbe",
      selector: "orderNumber",
      sortable: true,
      center: true,
    },


    {
      name: "Order Date Time",
      selector: "orderDate",
      style: { fontSize: "16px" },
      align: "center",
    },
    {
      name: "Item Weight (kg)",
      selector: "weightInKg",
      center: true,
      style: { fontSize: "16px" },
    },

  ];

  const warehouseCol = [

    {
      name: "Consignment Number",
      selector: row => row.orderNumber,
      sortField: 'orderNumber',
    },
    {
      name: "Order Date Time",
      selector: row => row.orderDate,
      sortField: 'orderDate',

    },
    {
      name: "Sender City",
      selector: row => row.senderCity,
      sortField: 'senderCity',
    },
    {
      name: "Receiver City",
      selector: row => row.receiverCity,
      sortField: 'receiverCity',
    },

    {
      name: "Total Weight (Kg)",
      selector: row => row.totalWeight,
      sortField: 'totalWeight',
    },
    {
      name: "Total Volume ",
      selector: row => row.totalVolume,
      sortField: 'totalVolume',
    },

    {
      name: "Driver Job Status",
      selector: row => row.jobStatus,
      sortField: 'jobStatus',
    },
    {
      name: "Picked Date Time",
      selector: row => row.pickedDateTime,
      sortField: 'pickedDateTime',
    },

    {
      name: "Reached Date Time",
      selector: row => row.reachedDateTime,
      sortField: 'reachedDateTime',
    },

    {
      name: "Warehouse Recieved Date Time",
      selector: row => row.warehouseRecievedDateTime,
      sortField: 'warehouseRecievedDateTime',
    },

    {
      name: "Actions",
      cell: (row) => (
        <Grid container spacing={5} mt={-6.2} justifyContent={"center"}>
          {row.shipmentTypeAndID.jobStatus === "Job Reached" || row.shipmentTypeAndID.jobStatus === "To be Dropped" ?
            <Grid item style={{ marginLeft: "-20px" }}>
              <Link to={``} onClick={() => { generateQRCode(row.shipmentTypeAndID.ID) }}>
                <TimelineItem color="info" icon={<QrCodeIcon />} title="Barcode" />
              </Link>
            </Grid>
            :
            <Grid item style={{ marginLeft: "-20px" }}>
              <TimelineItem color="grey" icon={<QrCodeIcon />} title="Barcode" />
            </Grid>

          }
          <Grid item>
            <Link to={`/viewDetailsWarehouse/${row.shipmentTypeAndID.ID}`}>
              <TimelineItem color="info" icon="visibility" title="View" />
            </Link>
          </Grid>
          {row.shipmentTypeAndID.jobStatus === "Job Reached" || row.shipmentTypeAndID.jobStatus === "Job Dropped" || row.shipmentTypeAndID.jobStatus === "To be Dropped" ?
            <Grid item>
              <Link to={row.shipmentTypeAndID.loadPlanVehiclesID !== "" && row.shipmentTypeAndID.loadPlanVehiclesID !== undefined ? `/recieveOder/${row.shipmentTypeAndID.ID}?LoadID=${row.shipmentTypeAndID.loadPlanVehiclesID}` : `/recieveOder/${row.shipmentTypeAndID.ID}`}>
                <TimelineItem color="info" icon={<CheckBoxIcon />} title="Receive Order" />
              </Link>
            </Grid>
            :
            <Grid item>
              <TimelineItem color="grey" icon={<CheckBoxIcon />} title="Received Order" />
            </Grid>

          }
        </Grid>
      ),
    },
  ]
const loadFinalOrder=[
  {
    name: "Consignment Number",
    selector: row => row.orderNumber,
    sortField: 'orderNumber',
  },
  {
    name: "Order Date Time",
    selector: row => row.orderDate,
    sortField: 'orderDate',

  },
  {
    name: "Sender City",
    selector: row => row.senderCity,
    sortField: 'senderCity',
  },
  {
    name: "Receiver City",
    selector: row => row.receiverCity,
    sortField: 'receiverCity',
  },

  {
    name: "Total Weight (Kg)",
    selector: row => row.totalWeight,
    sortField: 'totalWeight',
  },
  {
    name: "Total Volume ",
    selector: row => row.totalVolume,
    sortField: 'totalVolume',
  },

  {
    name: "Driver Job Status",
    selector: row => row.jobStatus,
    sortField: 'jobStatus',
  },

  {
    name: "Actions",
    cell: (row) => (
      <Grid container spacing={5} mt={-6.2} justifyContent={"center"}>
   {row.shipmentTypeAndID.jobStatus === "Job Rejected" ? (
              <Grid item>
                <TimelineItem
                  color="info"
                  icon="visibility"
                  title="Reasign Order"
                  onClick={() => {
                    setOpenAssignDriver(true);
                    values.jobID = row.shipmentTypeAndID.jobID;
                  }}
                />
              </Grid>
            ) : (
              <Grid item>
                <TimelineItem color="grey" icon="visibility" title="Reasign Order" />
              </Grid>
            )}
      </Grid>
    ),
 
  },
  

]
const loadWTWOrder =[
  {
    name: "Consignment Number",
    selector: row => row.orderNumber,
    sortField: 'orderNumber',
  },
  {
    name: "Order Date Time",
    selector: row => row.orderDate,
    sortField: 'orderDate',

  },
  {
    name: "Sender City",
    selector: row => row.senderCity,
    sortField: 'senderCity',
  },
  {
    name: "Receiver City",
    selector: row => row.receiverCity,
    sortField: 'receiverCity',
  },

  {
    name: "Total Weight (Kg)",
    selector: row => row.totalWeight,
    sortField: 'totalWeight',
  },
  {
    name: "Total Volume ",
    selector: row => row.totalVolume,
    sortField: 'totalVolume',
  },

  {
    name: "Driver Job Status",
    selector: row => row.jobStatus,
    sortField: 'jobStatus',
  },
  {
    Header: "Dropped Date Time",
    accessor: "droppedDateTime",
    align: "center",
    style: { fontSize: "16px" },
  },

  {
    name: "Actions",
    cell: (row) => (
      <Grid container spacing={5} mt={-6.2} justifyContent={"center"}>
   {row.shipmentTypeAndID.jobStatus === "Job Rejected" ? (
              <Grid item>
                <TimelineItem
                  color="info"
                  icon="visibility"
                  title="Reasign Order"
                  onClick={() => {
                    setOpenAssignDriver(true);
                    values.jobID = row.shipmentTypeAndID.jobID;
                  }}
                />
              </Grid>
            ) : (
              <Grid item>
                <TimelineItem color="grey" icon="visibility" title="Reasign Order" />
              </Grid>
            )}
      </Grid>
    ),
 
  },
  

]








  const finalCol = [
    {
      name: "Consignment Numbe",
      selector: "orderNumber",
      sortable: true,
    },
    {
      name: "Order Date Time",
      selector: "orderDate",
      style: { fontSize: "16px" },
      align: "center",
    },

    {
      name: "Sender City",
      selector: "senderCity",
      style: { fontSize: "16px" },
      align: "center",
    },

    {
      name: "Receiver City",
      selector: "receiverCity",
      style: { fontSize: "16px" },
    },
    {
      name: "Total Weight (Kg)",
      selector: "totalWeight",
      style: { fontSize: "16px" },
    },
    {
      name: "Total Volume (mm3)",
      selector: "totalVolume",
      style: { fontSize: "16px" },
    },

  ];



  const received = (
    <>
      {showReceived && (
        <Grid conatainer>
          <Grid item lg={12}>
            <MDBox pt={6}>

              <CardContent>
                <BTable

                  columns={warehouseCol}
                  data={rows}
                  selectableRows
                  sortingType={handleSort}
                  sortServer
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  onSelectedRowsChange={handleChange2}
                  fixedHeaderScrollHeight="410px"
                  fixedHeader={true}

                />
              </CardContent>

            </MDBox>
          </Grid>{" "}
        </Grid>
      )}
    </>
  );

  const allocation = (
    <>


      {showPlanFeatureTable && (
        <>
          {
            showViewDetails && <>
              <Grid container pt={5} pb={5} px={5}>
                <Grid item lg={12}>
                  {rows1.length > 0 &&
                    <Printer printerData={rows1}  state={(e) =>{
                      setShowViewDetails(e)
                    }}/>
                  }
                </Grid>
              </Grid>
            </>

          }
          {!showViewDetails && <>
            {showLockVehicle && (
              <Grid container px={3} mt={5}>
                <CustomText type="b" size={15} style={{ color: "black" }}>
                  Lock Trailer
                </CustomText>
              </Grid>
            )}

            <Grid
              container
              px={2}
              mt={showVehicleDropdown || showLockVehicle ? 1 : 5}
              columnSpacing={2}

            >
              <Grid item xs={3} md={3} lg={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Delivery Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ minHeight: "3.1em" }}
                    label="Delivery Type"
                    className="selector"
                    value={values.deliveryType}
                    onChange={handleChange("deliveryType")}

                  >
                    <MenuItem value="Warehouse to Warehouse">Warehouse to Warehouse</MenuItem>
                    <MenuItem value="Final Delivery">Final Delivery</MenuItem>

                  </Select>
                </FormControl>
              </Grid>
              {values.deliveryType === "Warehouse to Warehouse" && <>
                <Grid item xs={3} md={3} lg={2}>
                  <FormControl fullWidth >
                    <InputLabel id="demo-simple-select-label">Load Plan Vehicle</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      className="selector"
                      style={{ minHeight: "3.1em" }}
                      label="Load Plan Vehicle"
                      disabled={showVehicleDropdown === true ? true : false}
                      value={values.loadPlanVehicleID}
                      onChange={handleChange("loadPlanVehicleID")}
                    >
                      {VehicleList}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3} md={3} lg={2}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Drop Location</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ minHeight: "3.1em" }}
                      className="selector"
                      label="Drop Location"
                      disabled={values.loadPlanVehicleID === "" || values.loadPlanVehicleID === undefined ? true : false}
                      value={values.orderDropWarehouseID}
                      onChange={handleChange("orderDropWarehouseID")}
                    >
                      {DropLocationList}
                    </Select>
                  </FormControl>
                </Grid>
              </>}

              {values.deliveryType === "Final Delivery" &&
                <Grid item xs={3} md={3} lg={1.5}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Select Driver</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ minHeight: "44.11px" }}
                      label="Select Driver"
                      value={values.assignedDriverID}
                      onChange={handleChange("assignedDriverID")}
                    >
                      {DriverList}

                    </Select>
                    {selectDriverErr ? <span style={errMsg}>Driver can't be blank</span> : ""}
                  </FormControl>
                </Grid>


              }

              {values.deliveryType === "Warehouse to Warehouse" && <>
                <Grid item xs={12} md={4} spacing={2} lg={1.5}>

                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="success"
                    onClick={setOpenModal}
                    // style={{backgroundColor:'red',color:'white'}}
                    fullWidth
                  >
                    {lock === "Locked" ?
                      <>
                        Unlock Trailer
                      </>
                      : <>
                        Lock Trailer
                      </>}

                  </MDButton>

                </Grid>
                {lock === "Locked" &&
                  <Grid item xs={12} md={4} spacing={2} lg={1.5}>
                    <MDButton
                      onClick={setOpenAssignDriver}
                      rel="noreferrer"
                      variant="gradient"
                      color="success"
                      fullWidth

                    >
                      Assign Driver
                    </MDButton>
                  </Grid>
                }
                <Grid item xs={12} md={4} spacing={2} lg={1.5}>
                  <MDButton
                    onClick={setPrreview}
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    fullWidth

                  >
                    Preview Trailer
                  </MDButton>
                </Grid>






              </>}
              {values.deliveryType === "Final Delivery" ? <>
                <Grid item xs={12} md={4} spacing={2} lg={1.5}>
                  <MDButton
                    onClick={allocateDriverFinalDelivery}
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    fullWidth
                  >
                    Assign Driver
                  </MDButton>
                </Grid>
              </> : <>
                <Grid item xs={12} md={4} spacing={2} lg={1.5}>
                  <MDButton
                    onClick={addLoadVehicleAndSlot}
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    disabled={lock === "Locked" ? true : false}
                    fullWidth
                  >
                    Allocate
                  </MDButton>
                </Grid>
              </>
              }
            </Grid>
            {values.deliveryType === "Warehouse to Warehouse" && <>
              <Grid container columnSpacing={2} px={2} >
                <Grid item lg={6} mt={1.5}>
                  <MDBox >
                    <NewDataTable
                      // title="Select Item"
                      columns={ordersColumns}
                      data={rows4}
                      defaultSortFieldId={1}
                      pagination={true}
                      highlightOnHover={true}
                      selectableRows={true}
                      onSelectedRowsChange={handleChange1}
                      selectableRowDisabled={rowDisabledCriteria}
                      fixedHeader={true}
                      fixedHeaderScrollHeight="500px"
                    />
                  </MDBox>
                </Grid>
                {vehicleValues.trailerType === "Mezz" && <>
                  <Grid item lg={6} style={{ height: '500px', overflow: 'auto' }}>
                    <Grid container spacing={2}>

                      <Grid item lg={12} mt={5}>
                        <Typography id="modal-modal-title" variant="h3" component="h2" style={{ fontSize: "20px", textAlign: "center" }}>
                          Normal
                        </Typography>
                        <Grid container spacing={2} >
                          {slotData.map((val, i) => (
                            <Grid item lg={6} >
                              <Card style={{ background: "aliceblue" }}>
                                <Grid container px={2} py={2} >
                                  <Grid item lg={4}>
                                    <FormGroup onChange={slotsHandleChange('_id', i)} value={val._id} >
                                      <FormControlLabel className="checked" control={<Checkbox />} label={`Slot ${val.slotNumber}`} />
                                    </FormGroup>
                                  </Grid>
                                  <Grid item lg={4}>
                                    <Typography id="modal-modal-title" variant="b" component="b" style={{ fontSize: "12px", justifyContent: 'center', display: 'grid' }}>
                                      Loaded Volume(m3)<br /><p style={{ textAlign: 'center', fontSize: "20px" }}>{val.loadedVolume} </p>
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={4}>
                                    <Typography id="modal-modal-title" variant="b" component="b" style={{ fontSize: "12px", justifyContent: 'center', display: 'grid' }}>
                                      Avl Balance(m3) <br /><p style={{ textAlign: 'center', fontSize: "20px" }}>{val.balanceVolume}</p>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                      <Grid item lg={12} mt={5}>
                        <Typography id="modal-modal-title" variant="h3" component="h2" style={{ fontSize: "20px", textAlign: "center" }}>
                          Mezz
                        </Typography>
                        <Grid container spacing={2} >
                          {vehicleValues.trailerType === "Mezz" && <>
                            {mezzSlot.map((val, i) => (
                              <Grid item lg={6} >
                                <Card style={{ background: "aliceblue" }}>
                                  <Grid container px={2} py={2}>
                                    <Grid item lg={4}>
                                      <FormGroup onChange={mezzSlotsHandleChange('_id', i)}>
                                        <FormControlLabel className="checked" control={<Checkbox />} label={`Mez ${val.slotNumber}`} />
                                      </FormGroup>
                                    </Grid>
                                    <Grid item lg={4}>
                                      <Typography id="modal-modal-title" variant="b" component="b" style={{ fontSize: "12px", justifyContent: 'center', display: 'grid' }}>
                                        Loaded Volume(m3) <br /><h3 style={{ textAlign: 'center', fontSize: "20px" }}>{val.loadedVolume}</h3>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={4}>
                                      <Typography id="modal-modal-title" variant="b" component="b" style={{ fontSize: "12px", justifyContent: 'center', display: 'grid' }}>
                                        Avl Balance(m3)<br /><b style={{ textAlign: 'center', fontSize: "20px" }}>{val.balanceVolume}</b>
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Card>
                              </Grid>
                              // onChange={handleChange('_id', i)} value={val._id}
                            ))}</>
                          }
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </>}
                {vehicleValues.trailerType !== "Mezz" && slotData.length > 0 ? <>
                  <Grid item lg={6} mt={5}>
                    <Typography id="modal-modal-title" variant="h3" component="h2" style={{ fontSize: "20px", textAlign: "center" }}>
                      Normal
                    </Typography>
                    <MDBox style={{ height: '500px', overflow: 'auto', paddingleft: "10px", paddingRight: "10px" }}>

                      <Grid container spacing={2} >
                        {slotData.map((val, i) => (
                          <Grid item lg={6} >
                            <Card style={{ background: "aliceblue" }}>
                              <Grid container px={2} py={2}>
                                <Grid item lg={4} display={"flex"} alignItems={"center"}>
                                  <FormGroup onChange={slotsHandleChange('_id', i)} >
                                    <FormControlLabel className="checked setLabel" control={<Checkbox />} label={`Slot ${val.slotNumber}`} />
                                  </FormGroup>
                                </Grid>
                                <Grid item lg={4}>
                                  <Typography id="modal-modal-title" variant="b" component="b" style={{ fontSize: "12px", justifyContent: 'center', display: 'grid', textAlign: "center" }}>
                                    Loaded Volume(m3)<br /><p style={{ textAlign: 'center', fontSize: "20px" }}>{val.loadedVolume}</p>
                                  </Typography>
                                </Grid>
                                <Grid item lg={4}>
                                  <Typography id="modal-modal-title" variant="b" component="b" style={{ fontSize: "12px", justifyContent: 'center', display: 'grid', textAlign: "center" }}>
                                    Available Balance(m3) <br /><p style={{ textAlign: 'center', fontSize: "20px" }}>{val.balanceVolume}</p>
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        ))}



                      </Grid>
                    </MDBox>

                  </Grid>
                </> : <>
                  <Grid item lg={6} mt={5}>
                    <Typography id="modal-modal-title" variant="h3" component="h2" style={{ fontSize: "20px", textAlign: "center" }}>
                      Please Select Load Plan Vehicle.
                    </Typography>
                  </Grid>
                </>}
              </Grid>
            </>}
            {values.deliveryType === "Final Delivery" && <>

              <MDBox>
                <NewDataTable
                  // title="Select Item"
                  columns={finalCol}
                  data={finalRow}
                  defaultSortFieldId={1}
                  pagination
                  highlightOnHover
                  selectableRows
                  // onSelectedRowsChange={handleChange1}
                  fixedHeader={true}
                  fixedHeaderScrollHeight="500px"

                  onSelectedRowsChange={handleChange4}
                // onSelectedRowsChange={handleChange3}
                // selectableRowSelected={handleChange3}
                // selectableRows
                // onSelectedRowsChange={handleChange1}
                />
              </MDBox>

            </>}
            <Grid
              container
              mt={2}
              columnSpacing={4}
              alignItems="center"
              display="flex"
              justifyContent="center"
              pb={4}
            >
              <Grid item xs={12} md={4} spacing={2} lg={2}>
                <Link to={"/warehouseDashboard"}>
                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    fullWidth
                    onClick={() => setTable("received")}
                  >
                    Cancel
                  </MDButton>
                </Link>
              </Grid>
              {/* {values.deliveryType === "Final Delivery" ? <>
                <Grid item xs={12} md={4} spacing={2} lg={1.5}>
                  <MDButton
                    onClick={allocateDriverFinalDelivery}
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    fullWidth
                  >
                    Assign Driver
                  </MDButton>
                </Grid>
              </> : <>
                <Grid item xs={12} md={4} spacing={2} lg={1.5}>
                  <MDButton
                    onClick={addLoadVehicleAndSlot}
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    fullWidth
                  >
                    Allocate
                  </MDButton>
                </Grid>
              </> */}
              {/* } */}
            </Grid></>}
        </>
      )}
    </>
  );

  const orderRecieved = (
    <>
      {showOrderRecieved && (
        <>
          <Grid conatainer>
            <Grid item lg={12}>
              <DataTable
                style={{ marginTop: "0px" }}
                canSearch={true}
                selectedValue={false}
                addNew={false}
                table={{
                  filterable: true,
                  rows: [],
                  columns: [

                    {
                      Header: "Consignment Numbe",
                      accessor: "orderNumber",
                      align: "center",
                      style: { fontSize: "16px" },
                    },
                    {
                      Header: "Order Date Time",
                      accessor: "orderDate",
                      align: "left",
                      style: { fontSize: "16px" },
                    },
                    {
                      Header: "Sender City",
                      accessor: "senderCity",
                      align: "center",
                      style: { fontSize: "16px" },
                    },
                    {
                      Header: "Receiver City",
                      accessor: "receiverCity",
                      align: "center",
                      style: { fontSize: "16px" },
                    },

                    {
                      Header: "Total Weight (Kg)",
                      accessor: "totalWeight",
                      align: "center",

                      style: { fontSize: "16px" },
                    },
                    {
                      Header: "Total Volume (mm3)",
                      accessor: "totalVolume",
                      align: "center",
                      style: { fontSize: "16px" },
                    },

                    {
                      Header: "Warehouse Received Date Time",
                      accessor: "warehouseReceivedDateTime",
                      align: "center",
                      style: { fontSize: "16px" },
                    },
                    {
                      Header: "Driver Job Status",
                      accessor: "jobStatus",
                      align: "center",
                      style: { fontSize: "16px" },
                    },

                    {
                      Header: "actions",
                      align: "center",
                      accessor: "shipmentTypeAndID",
                      style: { fontSize: "16px" },
                      Cell: ({ value }) => (
                        <>

                          <Grid container spacing={5} mt={-6.2}>
                            {value.jobStatus === "Job Reached" ?
                              <Grid item style={{ marginLeft: "-20px" }}>
                                <Link to={``} onClick={() => { generateQRCode(value.ID) }}>
                                  <TimelineItem color="info" icon="visibility" title="Barcode" />
                                </Link>
                              </Grid>
                              :
                              <Grid item style={{ marginLeft: "-20px" }}>
                                <TimelineItem color="grey" icon="visibility" title="Barcode" />
                              </Grid>

                            }
                            <Grid item>
                              <Link to={`/viewDetailsWarehouse/${value.ID}`}>
                                <TimelineItem color="info" icon="visibility" title="View" />
                              </Link>
                            </Grid>

                            {value.jobStatus === "Job Reached" ?
                              <Grid item>
                                <Link to={`/recieveOder/${value.ID}`}>
                                  <TimelineItem color="info" icon="visibility" title="Recieve Order" />
                                </Link>
                              </Grid>
                              :
                              <Grid item>
                                <TimelineItem color="grey" icon="visibility" title="Recieve Order" />
                              </Grid>
                            }
                          </Grid>
                        </>
                      ),
                    },
                  ],
                }}
                isSorted={true}
                entriesPerPage={true}
                showTotalEntries={true}
                pagination={{ variant: "gradient" }}
                noEndBorder
              />
            </Grid>{" "}
          </Grid>
        </>
      )}</>
  );

  const locked = (
    <>
      {showLocked && (
        <>
          <Grid
            container
            px={2}
            mt={showVehicleDropdown || showLockVehicle ? 1 : 5}
            columnSpacing={2}
          >
            <Grid item xs={3} md={3} lg={3}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Load Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ minHeight: "3.1em" }}
                  label="load Type"
                  value={valuesSummary.loadType}
                  onChange={handleChangeSummary("loadType")}
                >
                  <MenuItem value="Warehouse to Warehouse">Warehouse to Warehouse</MenuItem>
                  <MenuItem value="Final Delivery">Final Delivery</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <MDBox mt={-3.5} pt= {4} >
            {valuesSummary.loadType === "Warehouse to Warehouse" ?
              <> 
              <CardContent>
                <BTable
                  columns={loadFinalOrder}
                  data={rows5}
                  sortingType={handleSort}
                  sortServer
                  pagination
                  paginationServer
                  paginationTotalRows={totalRowsLoaded}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  fixedHeaderScrollHeight="410px"
                  fixedHeader={true}

                />
              </CardContent>
              </>
              : <>
               <CardContent>
                <BTable
                  columns={loadWTWOrder}
                  data={rows5}
             
                  sortingType={handleSort}
                  sortServer
                  pagination
                  paginationServer
                  paginationTotalRows={totalRowsLoaded}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}

                  fixedHeaderScrollHeight="410px"
                  fixedHeader={true}

                />
              </CardContent>
              
              
              
              
              
        </>}

          </MDBox>
        </>
      )}
    </>
  );

  const renderTable = () => {
    return (
      <>
        {received}
        {orderRecieved}
        {allocation}
        {locked}
      </>
    );
  };

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <DashboardLayout>
      <DashboardNavbar />


      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container >
          <Grid item xs={12} md={6} lg={6} px={2} mb={-3.5}>

            <AppBar position="inherit">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                sx={{
                  "& .Mui-selected": { color: "#fff !important" },
                }}
              >
                <Tab
                  onClick={() => setTable("received")}
                  label="Orders Pending"

                />
                <Tab
                  onClick={() => setTable("allocated")}
                  label="Orders Allocation"

                />
                <Tab onClick={() => setTable("locked")} label="Orders Loaded" />

              </Tabs>


            </AppBar>



          </Grid>
          {table === "received" &&
            <Grid item xs={12} md={4} spacing={2} lg={1.5}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="success"
                onClick={handleRecieveOrder}
                // style={{backgroundColor:'red',color:'white'}}
                fullWidth
              >
                Recieve Order
              </MDButton>

            </Grid>
          }

          <Grid item xs={12} md={4} lg={1}>

          </Grid>
          {showPlanFeatureTable && !showViewDetails && <>
            <Grid item xs={12} md={4} lg={2}>
              <TextField
                type="text"
                label="Search..."
                variant="outlined"
                fullWidth
                onChange={(e) => setFilterText(e.target.value)}
                value={filterText}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2.5} ml={2}>
              <TextField
                type="text"
                label="Barcode"
                variant="outlined"
                fullWidth
                onChange={(e) => setFilterBarcode(e.target.value)}
                value={filterBarcode}

              />
              {barCodeErr ? <span style={errMsg}>Enter Valid Barcode</span> : ""}
            </Grid>

          </>
          }
        </Grid>
        {renderTable()}
      </Card>

      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card sx={style}>
          <Box>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>

            </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
              {lock === "Locked" ? <>
                Would you like to Unlock this load plan vehicle?
              </> : <>
                Would you like to Lock this load plan vehicle?
              </>}

            </Typography>
            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" onClick={cancel} sx={{ width: "64px", textTransform: "capitalize" }}>
                No
              </MDButton>
              &nbsp; &nbsp;
              <MDButton color="error" onClick={lockTrailor} sx={{ width: "64px", textTransform: "capitalize" }}>
                Yes
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>




      <Modal
        open={openRecieveOrder}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card sx={style}>
          <Box>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>

            </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
              Would you like to Recieve Selected Order?
            </Typography>
            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" onClick={() => setOpenRecieveOrder(false)} sx={{ width: "64px", textTransform: "capitalize" }}>
                No
              </MDButton>
              &nbsp; &nbsp;
              <MDButton color="error" onClick={recieveOrder} sx={{ width: "64px", textTransform: "capitalize" }}>
                Yes
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>



      <Modal

        open={openAssignDriver}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ViewCard sx={style1}>
          <Box>

            <Height val={20} />
            <Grid item xs={3} md={3} lg={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select Vehicle</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ minHeight: "3.1em" }}
                  label="Select Vehicle"
                  value={values.vehicleID}
                  onChange={handleChange("vehicleID")}
                >
                  {primeMoverList}
                </Select>
                {assignVehicleErr ? <span style={errMsg}>Vehicle can't be blank</span> : ""}
              </FormControl>
            </Grid>
            <Height val={10} />


            <Grid item xs={12} lg={12}>

              <FormControl fullWidth>
                <InputLabel id="demo-multiple-checkbox-label">Load Plan Vehicles</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  style={{ minHeight: "3em" }}
                  value={selectedNames}
                  onChange={(e) => setSelectedNames(e.target.value)}
                  input={<OutlinedInput label="Load Plan Vehicles" />}
                  renderValue={(selected) => {
                    const selectedNames = lockedVehicle.filter((name) => selected.includes(name._id));
                    return selectedNames.map((name) => `${name.registrationNumber},${name.vehicleType}`).join(', ');
                  }}
                >
                  {lockedVehicle.map((name) => (
                    <MenuItem key={name._id} value={name._id}>
                      <Checkbox checked={selectedNames.indexOf(name._id) > -1} />
                      <ListItemText primary={`${name.registrationNumber},${name.vehicleType}`} />
                    </MenuItem>
                  ))}
                </Select>
                {assignloadPlanVehicleErr ? <span style={errMsg}>Load Plan Vehicles can't be blank</span> : ""}
              </FormControl>

            </Grid>
            <Height val={10} />
            <Grid item xs={3} md={3} lg={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select Drop Warehouse</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ minHeight: "3.1em" }}
                  label="Select Drop Warehouse"
                  disabled={selectedNames.length > 0 ? false : true}
                  value={values.dropWarehouseID}
                  onChange={handleChange("dropWarehouseID")}
                >
                  {warehouse}
                </Select>
                {assignDropWarehouseErr ? <span style={errMsg}>Drop Warehouse can't be blank</span> : ""}
              </FormControl>
            </Grid>
            <Height val={10} />
            <Grid item xs={3} md={3} lg={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select Driver</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ minHeight: "3.1em" }}
                  label="Select Driver"
                  value={values.assignedDriverID}
                  onChange={handleChange("assignedDriverID")}
                >
                  {DriverList}
                </Select>
                {assignDriverErr ? <span style={errMsg}>Driver can't be blank</span> : ""}
              </FormControl>
            </Grid>

            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" onClick={cancel} sx={{ width: "64px", textTransform: "capitalize" }}>
                Cancel
              </MDButton>
              &nbsp; &nbsp;
              <MDButton color="success" onClick={saveDriver} sx={{ width: "64px", textTransform: "capitalize" }}>
                Save
              </MDButton>
            </Grid>
          </Box>
        </ViewCard>
      </Modal>
    </DashboardLayout>
  );
}

export default WarehouseDashboard;
